// extracted by mini-css-extract-plugin
export default {"list":"general-features_list__nvfpG"};